// Types are <Handler><Verb><Noun> e.i. BulkDeteleSessions, BulkMoveProjects, etc.
// TODO: Rename these to handle more containers than Session
export enum BulkMoveSessionsConflictMode {
  SKIP = 'skip',
  MOVE = 'move',
  DRY = 'dry',
}

export type BulkMoveSessionsConflict = {
  id: string
  label: string
  subject_code: string
}

export interface BulkMoveSessions {
  destination_container_type: string,
  // sources, array of session Ids that you would like to bulk move
  sources: string[],
  // destination, array with a single container Id of the destination container's Id
  destinations: string[],
  conflict_mode?: BulkMoveSessionsConflictMode,
}

